import { ErrorHandler, Inject, Injectable, Injector } from "@angular/core";
import { OKTA_AUTH } from "@okta/okta-angular";
import { OktaAuth } from "@okta/okta-auth-js";
import { AppInsightsService, LoggingService } from "../services";


@Injectable({
  providedIn: 'root'
})
export class ApplicationInsightsErrorHandler extends ErrorHandler {
  constructor(private injector: Injector, @Inject(OKTA_AUTH) private oktaAuth: OktaAuth) {
    super();
  }

  handleError(error: any): void {
    // injecting ApplicationInsightService via injector to avoid infinite loop in case
    // error is with service itself

    // Try to get the current user
    this.oktaAuth.getUser().then(userClaim => {
      var user: string = '';

      if (userClaim) {
        user = userClaim.sub;
      }

      this.injector.get<AppInsightsService>(AppInsightsService).logException(error);
      this.injector.get<LoggingService>(LoggingService).log(error, user);
      super.handleError(error); // optional
      // add any customer error handling here

    });



  }
}
